import { Avatar, styled } from "@mui/material";

export const StoreAvatar = styled(Avatar)`
  height: 24px;
  width: 24px;
  margin-right: 5px;
  margin-left: 5px;
  object-fit: fill;
`;
